// extracted by mini-css-extract-plugin
module.exports = {"inputGroup":"Input_inputGroup__s_Tuf","containLabel":"Input_containLabel__1mYTu"};